import { roleAccent } from "./organigramaColors";

export const chiara = {
  id: "chiara",
  section: "2.3",
  name: "Chiara Santucci",
  role: "Product & Design Lead – NML Spain",
  subtitle: null,
  reportaA: "Head of Product & Design",
  colaboraCon:
    "Founder & Chief Product, Commercial & Partnerships Officer, Business Development, COFO, Business Operations Coordinator, equipos de diseño y merchandising de China, Camboya, Turquía y NML Denmark.",
  accent: roleAccent("chiara"),
  foco: [],
  noFoco: [],
  misionLabel: "Misión",
  mision:
    "Liderar el desarrollo de producto de NML Spain, convirtiendo la estrategia comercial en propuestas diferenciales, comercialmente sólidas y técnicamente viables.\n\nEs responsable del Spain Drop, del calendario de desarrollo y de elevar el nivel de diseño de NML Spain, complementando y enriqueciendo las colecciones desarrolladas por NML Denmark.",
  responsabilidadesLabel: "Áreas de responsabilidad",
  responsabilidades: [
    {
      title: "Dirección del Spain Drop",
      items: [
        "Liderar el desarrollo del Spain Drop de No Man's Label.",
        "Definir la arquitectura del Spain Drop junto con Head of Product & Design y Founder.",
        "Asegurar coherencia entre categorías, tejidos, colorido y posicionamiento.",
        "Garantizar equilibrio entre creatividad, comercialidad, coste y viabilidad industrial.",
        "Asegurar que el Spain Drop aporte valor añadido a la colección global de NML.",
      ],
    },
    {
      title: "Desarrollo de producto",
      items: [
        "Desarrollar propuestas de producto para clientes asignados a NML Spain.",
        "Traducir necesidades comerciales en prendas viables y atractivas.",
      ],
      groups: [
        {
          label: "Asegurar que cada desarrollo responde a:",
          items: [
            "identidad del cliente",
            "rango de precios objetivo",
            "calendario",
            "viabilidad técnica",
            "oportunidad comercial",
          ],
        },
      ],
    },
    {
      title: "Liderazgo técnico en tejidos",
      items: [
        "Ser la referencia interna en tejidos para prendas fluidas.",
        "Investigar nuevos tejidos, composiciones, acabados y proveedores.",
        "Mantener una biblioteca viva y ordenada de tejidos.",
        "Compartir conocimiento con el equipo mediante sesiones internas.",
        "Ayudar al equipo a entender comportamiento, coste, calidad y posibilidades de cada tejido.",
      ],
    },
    {
      title: "Gestión de prioridades y calendario",
      items: [
        "Organizar el calendario del Spain Drop.",
        "Priorizar proyectos en función de impacto comercial, cliente y timing.",
        "Anticipar retrasos y proponer soluciones.",
        "Asegurar que la velocidad de ejecución esté al nivel de la calidad de diseño.",
      ],
    },
    {
      title: "Liderazgo del equipo NML Spain",
      items: [
        "Coordinar a las diseñadoras internas asignadas a NML.",
        "Coordinar diseño externo en China cuando aplique.",
        "Delegar tareas con claridad.",
        "Acompañar y desarrollar al equipo.",
        "Asegurar que cada persona entiende prioridades, deadlines y estándar esperado.",
      ],
    },
    {
      title: "Showroom NML Spain",
      items: [
        "Asegurar que el showroom de NML Spain esté actualizado y preparado.",
        "Seleccionar prendas, tejidos y propuestas relevantes.",
        "Garantizar que el showroom inspire al cliente y facilite la venta.",
      ],
    },
    {
      title: "Reuniones con clientes",
      items: [
        "Preparar junto con los Business Development las reuniones con clientes.",
        "Seleccionar y organizar las prendas, tejidos y desarrollos que mejor respondan a los objetivos de cada visita.",
        "Participar en reuniones comerciales cuando sea requerido, aportando conocimiento de producto, tejidos y desarrollo.",
        "Traducir el feedback recibido durante las reuniones en acciones concretas para el equipo de diseño.",
        "Contribuir a que cada reunión transmita profesionalidad, creatividad y un profundo conocimiento del cliente.",
      ],
    },
    {
      title: "Innovación",
      items: [
        "Impulsar el uso de AI, herramientas digitales y nuevas metodologías de diseño.",
        "Detectar nuevas tendencias y transformarlas en producto comercial.",
        "Proponer mejoras en presentaciones, storytelling y desarrollo.",
      ],
    },
  ],
  kpiGroups: [
    {
      title: "Producto",
      items: [
        "Hit rate de muestras.",
        "Nivel comercial del Spain Drop.",
        "Número de desarrollos convertidos en pedidos.",
        "Calidad de las propuestas presentadas.",
      ],
    },
    {
      title: "Timings",
      items: [
        "Spain Drop entregados dentro del calendario previsto.",
        "Reducción de retrasos por falta de planificación.",
        "Cumplimiento de fechas clave.",
      ],
    },
    {
      title: "Tejidos",
      items: [
        "Biblioteca de tejidos actualizada.",
        "Nuevos tejidos incorporados.",
        "Sesiones internas de formación en tejidos.",
        "Mejora del criterio técnico del equipo.",
      ],
    },
    {
      title: "Equipo",
      items: [
        "Nivel de autonomía de las diseñadoras NML Spain.",
        "Calidad de delegación.",
        "Cumplimiento de tareas asignadas.",
        "Mejora del nivel técnico y comercial del equipo.",
      ],
    },
    {
      title: "Cliente",
      items: [
        "Valoración positiva de las colecciones.",
        "Preparación de reuniones y presentaciones.",
        "Satisfacción de Business Development.",
      ],
    },
  ],
  kpis: [],
};

export const disenadoras = {
  id: "disenadoras",
  section: "2.4",
  name: "Diseñadoras",
  role: "Designer / Product Designer",
  subtitle:
    "Aplica a: Ana, Alejandra, Gemma y nuevas incorporaciones de diseño",
  reportaAItems: [
    "Head of Product & Design",
    "Cuando trabajen en proyectos NML Spain: reportan funcionalmente a Product & Design Lead – NML Spain",
  ],
  colaboraCon:
    "Business Development, merchandising, proveedores, equipos de China, Camboya, India y Turquía.",
  accent: roleAccent("disenadoras"),
  foco: [],
  noFoco: [],
  misionLabel: "Misión",
  mision:
    "Crear propuestas de producto innovadoras, comerciales y técnicamente viables, alineadas con la estrategia de cada cliente, los rangos de precio, los timings y el nivel creativo esperado por Stage Design Studio y No Man's Label.\n\nSu misión es transformar tendencias, materiales y necesidades de cliente en desarrollos claros, vendibles y ejecutables.",
  responsabilidadesLabel: "Áreas de responsabilidad",
  responsabilidades: [
    {
      title: "Diseño y desarrollo de producto",
      items: [
        "Diseñar prendas alineadas con el posicionamiento del cliente.",
        "Crear propuestas dentro de los rangos de precio objetivo.",
        "Desarrollar diseños técnicamente viables.",
        "Preparar tech files simples, claros y completos.",
        "Asegurar que cada propuesta pueda ser entendida y ejecutada correctamente por proveedores.",
      ],
    },
    {
      title: "Investigación de tendencias",
      items: [
        "Investigar desfiles, marcas nicho, retail, street style, colores, formas y materiales.",
        "Traducir tendencias en propuestas relevantes para los clientes.",
        "Compartir referencias de forma ordenada con el equipo.",
        "Mantener una actitud curiosa y activa frente al mercado.",
      ],
    },
    {
      title: "Sourcing",
      items: [
        "Buscar nuevos tejidos, fornituras, acabados y proveedores.",
        "Trabajar dentro del rango de precio de cada cliente.",
        "Alimentar la biblioteca de materiales.",
        "Compartir descubrimientos relevantes con Head of Product & Design y el equipo.",
      ],
    },
    {
      title: "Presentaciones",
      items: [
        "Preparar moodboards, fichas, paneles y propuestas visuales.",
        "Asegurar que las presentaciones transmiten claridad, creatividad y valor añadido.",
        "Adaptar el storytelling al cliente y a la categoría.",
      ],
    },
    {
      title: "Apoyo a reuniones con clientes",
      items: [
        "Colaborar en la preparación de reuniones con clientes.",
        "Preparar muestras, moodboards, tejidos, paneles y documentación de apoyo.",
        "Participar en reuniones cuando sea requerido, presentando desarrollos y dando soporte técnico al equipo comercial.",
        "Recoger y documentar el feedback recibido para incorporarlo correctamente al desarrollo de producto.",
        "Contribuir a ofrecer una experiencia excelente al cliente en cada visita.",
      ],
    },
    {
      title: "Showrooms",
      items: [
        "Colaborar en la actualización de showrooms.",
        "Mantener ordenadas las áreas asignadas.",
        "Asegurar que las prendas, tejidos y referencias estén correctamente presentadas.",
        "Preparar espacios antes de visitas de clientes.",
      ],
    },
    {
      title: "Documentación",
      items: [
        "Guardar toda la información en el servidor correspondiente.",
        "Mantener tech files, imágenes, referencias y comentarios actualizados.",
        "Facilitar que otros equipos puedan encontrar la información necesaria sin depender de una persona.",
      ],
    },
    {
      title: "Cumplimiento de plazos",
      items: [
        "Entregar diseños, fichas y comentarios dentro del calendario acordado.",
        "Avisar con antelación si existe riesgo de retraso.",
        "Priorizar correctamente cuando haya varios proyectos abiertos.",
        "Respetar timings de cliente y de proveedor.",
      ],
    },
    {
      title: "Colaboración",
      items: [
        "Trabajar con Business Development para entender necesidades de cliente.",
        "Trabajar con merchandising para asegurar viabilidad técnica y de coste.",
        "Comunicar de forma clara con proveedores y equipos de Asia.",
        "Escuchar feedback y convertirlo en mejoras concretas.",
      ],
    },
    {
      title: "Innovación y herramientas",
      items: [
        "Usar AI, 3D y herramientas digitales cuando aporten valor.",
        "Mejorar la velocidad y calidad del trabajo mediante nuevas metodologías.",
        "Aprender y compartir nuevas formas de trabajar.",
      ],
    },
  ],
  kpiGroups: [
    {
      title: "Diseño",
      items: [
        "Calidad creativa de propuestas.",
        "Nivel de adecuación al cliente.",
        "Viabilidad técnica de diseños.",
        "Calidad de tech files.",
      ],
    },
    {
      title: "Comercial",
      items: [
        "Hit rate de muestras.",
        "Número de desarrollos convertidos en pedidos.",
        "Valoración de Business Development.",
      ],
    },
    {
      title: "Organización",
      items: [
        "Cumplimiento de deadlines.",
        "Orden de documentación.",
        "Actualización de showrooms y biblioteca de materiales.",
        "Capacidad de priorización.",
      ],
    },
    {
      title: "Sourcing",
      items: [
        "Nuevos tejidos / fornituras aportados.",
        "Relevancia de los materiales propuestos.",
        "Adecuación a precio objetivo.",
      ],
    },
    {
      title: "Colaboración",
      items: [
        "Claridad de comunicación.",
        "Calidad del trabajo en equipo.",
        "Capacidad de incorporar feedback.",
        "Nivel de autonomía.",
      ],
    },
  ],
  kpis: [],
};

export const alex = {
  id: "alex",
  section: "2.5",
  name: "Alex Menéndez",
  role: "Graphic, AI & Digital Design Specialist",
  subtitle: null,
  reportaAItems: [
    "Head of Product & Design (Agustina)",
    "Colabora estrechamente con el Executive Chair (Miguel) en innovación, tecnología e Inteligencia Artificial.",
  ],
  colaboraCon:
    "Founder & Chief Product, Commercial & Partnerships Officer, Business Development, Diseño, COFO y Business Operations Coordinator.",
  accent: roleAccent("alex"),
  foco: [],
  noFoco: [],
  misionLabel: "Misión",
  mision:
    "Garantizar una identidad visual sólida, coherente y profesional para Stage Design Studio y No Man's Label, impulsando la innovación mediante el uso de herramientas digitales, 3D e Inteligencia Artificial.\n\nSu misión es ayudar a que la empresa comunique mejor, venda mejor y trabaje de forma más eficiente mediante soluciones creativas y tecnológicas.",
  responsabilidadesLabel: "Áreas de responsabilidad",
  responsabilidades: [
    {
      title: "Identidad Visual (House Style)",
      items: [
        "Responsable de mantener y desarrollar la identidad visual de Stage Design Studio y No Man's Label.",
      ],
      groups: [
        {
          label: "Garantizar la coherencia gráfica en:",
          items: [
            "Presentaciones.",
            "Company Profiles.",
            "Catálogos.",
            "Showrooms.",
            "Documentación comercial.",
            "Plantillas corporativas.",
            "Material de comunicación interna y externa.",
          ],
        },
      ],
    },
    {
      title: "Presentaciones Comerciales",
      items: [
        "Diseñar y preparar todo el material gráfico necesario para apoyar al equipo comercial.",
        "Su objetivo es ayudar a transmitir una imagen profesional y diferenciadora de la empresa.",
      ],
      groups: [
        {
          label: "Incluye:",
          items: [
            "Presentaciones de clientes.",
            "Moodboards.",
            "Presentaciones de categorías.",
            "Presentaciones de proveedores.",
            "Proyectos especiales.",
            "Material para ferias y visitas.",
          ],
        },
      ],
    },
    {
      title: "Branding y Comunicación",
      items: [
        "Velar por que toda la comunicación mantenga un mismo lenguaje visual.",
      ],
      groups: [
        {
          label: "Responsable del desarrollo gráfico de:",
          items: [
            "Etiquetas.",
            "Hangtags.",
            "Packaging.",
            "Flyers.",
            "Material promocional.",
            "Venta Privada.",
            "Comunicación corporativa.",
          ],
        },
      ],
    },
    {
      title: "Diseño de Prints",
      items: [
        "Trabajando junto al equipo de diseño para enriquecer las colecciones.",
      ],
      groups: [
        {
          label: "Desarrollar:",
          items: [
            "Prints.",
            "Gráficos.",
            "Artwork.",
            "Repeticiones.",
            "Adaptaciones para diferentes clientes.",
          ],
        },
      ],
    },
    {
      title: "Tecnología, IA e Innovación",
      items: ["Actuar como referente interno en innovación creativa."],
      groups: [
        {
          label: "Junto con el Executive Chair & CEO:",
          items: [
            "Investigar nuevas herramientas digitales.",
            "Evaluar aplicaciones de Inteligencia Artificial.",
            "Proponer mejoras de procesos.",
            "Identificar oportunidades de automatización.",
            "Compartir nuevas tecnologías con el resto del equipo.",
          ],
        },
      ],
    },
    {
      title: "Diseño 3D",
      items: [
        "Desarrollar representaciones digitales que permitan reducir muestras físicas, mejorar la comunicación con clientes, acelerar procesos de desarrollo y apoyar la sostenibilidad.",
      ],
    },
    {
      title: "Soporte Tecnológico",
      items: ["Coordinar con proveedores externos cuando sea necesario."],
      groups: [
        {
          label: "Dar soporte al equipo en:",
          items: [
            "software de diseño.",
            "hardware básico.",
            "impresoras.",
            "plotters.",
            "cartuchos.",
            "configuración de equipos.",
            "pequeñas incidencias informáticas.",
          ],
        },
      ],
    },
    {
      title: "Showrooms",
      items: ["Contribuyendo a mejorar la experiencia del cliente."],
      groups: [
        {
          label: "Responsable de:",
          items: [
            "imagen gráfica.",
            "cartelería.",
            "paneles.",
            "comunicación visual.",
            "materiales de apoyo.",
          ],
        },
      ],
    },
    {
      title: "Gestión documental",
      items: [
        "Mantener organizadas y actualizadas bibliotecas gráficas, logos, plantillas, imágenes, recursos digitales y archivos de impresión.",
      ],
    },
    {
      title: "Formación e Innovación",
      items: ["Contribuir al desarrollo tecnológico de toda la empresa."],
      groups: [
        {
          label: "Compartir periódicamente con el equipo:",
          items: [
            "nuevas herramientas.",
            "nuevas aplicaciones de IA.",
            "tendencias tecnológicas.",
            "buenas prácticas digitales.",
          ],
        },
      ],
    },
  ],
  kpiGroups: [
    {
      title: "Imagen Corporativa",
      items: [
        "Coherencia del House Style.",
        "Calidad visual de las presentaciones.",
        "Actualización de Company Profiles.",
        "Calidad del material comercial.",
      ],
    },
    {
      title: "Innovación",
      items: [
        "Nuevas herramientas implantadas.",
        "Uso efectivo de AI en la empresa.",
        "Automatizaciones implementadas.",
        "Formación interna realizada.",
      ],
    },
    {
      title: "Diseño",
      items: [
        "Calidad de los prints.",
        "Calidad de las presentaciones.",
        "Desarrollo de recursos gráficos.",
        "Uso del 3D en proyectos.",
      ],
    },
    {
      title: "Organización",
      items: [
        "Biblioteca gráfica organizada.",
        "Actualización de archivos.",
        "Tiempo de respuesta al equipo.",
        "Resolución de incidencias técnicas.",
      ],
    },
    {
      title: "Soporte",
      items: [
        "Satisfacción del equipo interno.",
        "Disponibilidad de herramientas.",
        "Funcionamiento de equipos e impresoras.",
        "Rapidez de resolución de incidencias.",
      ],
    },
  ],
  kpis: [],
};

export const nina = {
  id: "nina",
  section: "2.8",
  name: "Nina",
  role: "Sample Room & Product Support Specialist",
  subtitle: null,
  reportaA: "Head of Product & Design (Agustina)",
  colaboraCon:
    "Equipo de Diseño, Founder & Chief Product, Commercial & Partnerships Officer, Business Operations Coordinator, COFO, Business Development y equipos de merchandising.",
  accent: roleAccent("nina"),
  foco: [],
  noFoco: [],
  misionLabel: "Misión",
  mision:
    "Dar soporte al equipo de diseño y desarrollo garantizando que todas las muestras, prendas y materiales que pasan por Stage Design Studio y No Man's Label se presentan, registran y conservan con el máximo nivel de calidad y organización.\n\nContribuir a que el producto llegue siempre al cliente en las mejores condiciones posibles y a que el estudio ofrezca una experiencia excelente tanto al equipo interno como a los clientes.",
  responsabilidadesLabel: "Áreas de responsabilidad",
  responsabilidades: [
    {
      title: "Sample Room",
      items: [
        "Dar soporte al equipo de diseño en la gestión diaria del Sample Room.",
      ],
      groups: [
        {
          label: "Colaborar en:",
          items: [
            "Organización general de las muestras.",
            "Preparación de prendas para reuniones.",
            "Revisión del estado de las muestras.",
            "Apoyo en cambios de colección.",
          ],
        },
      ],
    },
    {
      title: "Preparación y mejora de muestras",
      items: [
        "Responsable de asegurar que todas las muestras presenten el mejor aspecto posible antes de ser utilizadas.",
      ],
      groups: [
        {
          label: "Esto incluye:",
          items: [
            "Planchar prendas.",
            "Cortar hilos.",
            "Realizar pequeños arreglos y ajustes.",
            "Mejorar acabados cuando sea posible.",
            "Preparar las prendas para presentaciones y reuniones.",
          ],
        },
        {
          label: "Además, aportar observaciones sobre:",
          items: [
            "Patronaje.",
            "Construcción.",
            "Acabados.",
            "Posibles mejoras técnicas.",
          ],
        },
      ],
    },
    {
      title: "Registro de desarrollos",
      items: [
        "Registrar en TON todos los desarrollos y muestras que llegan al estudio.",
      ],
      groups: [
        {
          label: "Responsable (soporte) de:",
          items: [
            "Fotografiar las prendas.",
            "Registrar la información correspondiente.",
            "Mantener actualizado el archivo digital de muestras.",
          ],
        },
      ],
    },
    {
      title: "Archivo de tejidos",
      items: [
        "Medir las prendas adquiridas durante shopping trips.",
        "Guardar una muestra representativa del tejido de cada prenda.",
        "Mantener una biblioteca física organizada que facilite la reproducción correcta de los desarrollos cuando sean seleccionados por un cliente.",
      ],
    },
    {
      title: "Apoyo al desarrollo de producto",
      items: ['Preparar "Frankies" y adaptaciones de prendas existentes.'],
      groups: [
        {
          label: "Dar soporte al equipo de diseño en:",
          items: [
            "Revisiones de muestras.",
            "Preparación de prendas.",
            "Comprobación de medidas.",
            "Desarrollo de nuevas propuestas.",
          ],
        },
      ],
    },
    {
      title: "Apoyo logístico",
      items: ["Actuar como back-up cuando sea necesario."],
      groups: [
        {
          label: "Dar soporte al Business Operations Coordinator en:",
          items: [
            "Preparación de envíos.",
            "Embalaje.",
            "Introducción de información en TON.",
            "Seguimiento administrativo de paquetería.",
          ],
        },
      ],
    },
    {
      title: "Apoyo al Showroom",
      items: [
        "Dar soporte al equipo de diseño en la preparación y mantenimiento de los showrooms.",
        "Contribuir a que cada prenda transmita el nivel de calidad y cuidado que caracteriza a Stage Design Studio y No Man's Label.",
      ],
      groups: [
        {
          label: "Colaborar en:",
          items: [
            "Planchar las prendas antes de las presentaciones.",
            "Cortar hilos y revisar acabados.",
            "Preparar las muestras para que presenten el mejor aspecto posible.",
            "Colgar y colocar las nuevas muestras siguiendo las indicaciones del equipo de diseño.",
            "Apoyar en los cambios de colección y actualizaciones del showroom.",
          ],
        },
      ],
    },
    {
      title: "Experiencia Cliente",
      items: [
        "Contribuir a que cada cliente se sienta bien recibido y perciba el cuidado y la hospitalidad que caracterizan a Stage Design Studio y No Man's Label.",
        "Entiende que la experiencia del cliente comienza mucho antes de empezar la presentación de la colección.",
      ],
      groups: [
        {
          label: "Contribuye en:",
          items: [
            "Preparar las salas de reuniones antes de cada visita.",
            "Organizar cafés, bebidas, desayunos y cualquier detalle necesario para recibir a los clientes.",
            "Asegurar que las muestras utilizadas durante las reuniones presenten siempre un aspecto impecable.",
            "Dar apoyo durante reuniones y presentaciones cuando sea necesario.",
          ],
        },
      ],
    },
    {
      title: "Venta Privada",
      items: [
        "Participar activamente en la organización y desarrollo de las tres Ventas Privadas anuales.",
      ],
      groups: [
        {
          label: "Colaborar en:",
          items: [
            "Preparación del producto.",
            "Organización del espacio.",
            "Atención al cliente.",
            "Reposición de prendas.",
            "Apoyo al equipo durante el evento.",
          ],
        },
      ],
    },
    {
      title: "Gestión del Taller de Muestras",
      items: ["Mantener operativo el taller de muestras."],
      groups: [
        {
          label: "Responsable de gestionar la compra y reposición de:",
          items: [
            "Hilos.",
            "Agujas.",
            "Entretelas.",
            "Material de costura.",
            "Herramientas necesarias para el correcto funcionamiento del taller.",
          ],
        },
      ],
    },
    {
      title: "Mejora Continua",
      items: [
        "Proponer mejoras en la organización del Sample Room.",
        "Contribuir a mejorar la preparación de las muestras.",
        "Compartir observaciones técnicas que puedan ayudar al equipo de diseño y merchandising.",
        "Mantener una actitud proactiva y colaborativa en el día a día.",
      ],
    },
  ],
  kpiGroups: [
    {
      title: "Producto",
      items: [
        "Calidad de las reparaciones y ajustes realizados.",
        "Calidad de presentación de las muestras.",
        "Exactitud de las mediciones.",
        "Calidad y actualización del archivo físico de tejidos.",
      ],
    },
    {
      title: "Organización",
      items: [
        "Exactitud del registro de muestras en TON.",
        "Rapidez en el registro de nuevos desarrollos.",
        "Disponibilidad y estado del taller de muestras.",
        "Calidad del apoyo logístico.",
      ],
    },
    {
      title: "Showroom",
      items: [
        "Estado de presentación de las muestras.",
        "Calidad de los acabados antes de reuniones y visitas.",
        "Rapidez en la preparación de nuevas colecciones.",
        "Nivel de apoyo al equipo de diseño.",
      ],
    },
    {
      title: "Cliente",
      items: [
        "Nivel de preparación de las visitas.",
        "Calidad de presentación de las muestras.",
        "Estado de las salas de reuniones antes de las visitas.",
        "Contribución a una experiencia excelente para el cliente.",
      ],
    },
  ],
  kpis: [],
};
